import { render, staticRenderFns } from "./SalesProjectsList.vue?vue&type=template&id=7b319d3a&scoped=true&"
import script from "./SalesProjectsList.vue?vue&type=script&lang=ts&"
export * from "./SalesProjectsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b319d3a",
  null
  
)

export default component.exports